import { createSlice } from "@reduxjs/toolkit";
import * as ErrorReducers from "../reducer/errorReducers";

export type ERROR_STATE = "NONE" | "ERROR" | "INFO";

export interface ErrorState {
  error: {
    isError: ERROR_STATE;
    errorMessage: string;
    errorTs: string | null;
    errorDisplayTime: number;
  };
}

function initialErrorState(): ErrorState {
  return {
    error: {
      isError: "NONE",
      errorMessage: "",
      errorTs: null,
      errorDisplayTime: 10000,
    },
  };
}

const errorSlice = createSlice({
  name: "error",
  initialState: initialErrorState(),
  reducers: { ...ErrorReducers },
});

const errorActions = errorSlice.actions;

export { errorActions, errorSlice };
